module.exports = __webpack_public_path__ + "static/media/MTL_ASC_PIO3.36305bff.png";